<template>
<div>
    <div class="modal fade" id="modal-container-newLogin" role="dialog" data-backdrop="static" aria-labelledby="myModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true"><img height="30px" src="@/assets/button/close_button.png" onkeydown="if(event.keyCode==13 || event.keyCode==32)return false;"/></button>
            <h3 class="modal-title F3-M-27" id="myModalLabel">
              <template v-if="routeInfo.routeId">
                ルート編集
              </template>
              <template v-else>
                ルートを登録
              </template>
            </h3>
          </div>
          <div class="modal-body">
            <div class="div_top slider">
              <table class="tb_top">
                <tr>
                  <td class="td_title F3-R-15 bgc8">運行区分</td>
                  <td class="F1-R-20">
                    <div class="contentSty" v-show="routeInfo.transportKind==0">
                      区域内
                    </div>
                    <div class="contentSty" v-show="routeInfo.transportKind==1">
                      区域外
                    </div>
                  </td>
                  <td class="td_title F3-R-15 bgc8" style="width: 200px;">ドライバーアプリ端末</td>
                  <td class="F1-R-20">
                    <div class="contentSty" v-show="routeInfo.routeType==0">
                      -
                    </div>
                    <div class="contentSty" v-show="routeInfo.routeType==1">
                      使用する
                    </div>
                    <div class="contentSty" v-show="routeInfo.routeType==2">
                      使用しない
                    </div>
                  </td>
                </tr>
                <tr>
                  <td class="td_title F3-R-15 bgc8">ルート名</td>
                  <td colspan="3" class="F1-R-20">
                    <div class="contentSty">
                      {{ routeInfo.routeName }}
                    </div>
                    </td>
                </tr>
                <template v-if="routeInfo.routeId">
                  <tr>
                    <td class="td_title F3-R-15 bgc8">ルートID</td>
                    <td colspan="3" class="F1-R-20">
                      <div class="contentSty">
                        {{ routeInfo.displayRouteId }}
                      </div>
                      </td>
                  </tr>
                </template>
                <tr v-for="(o, i) in routeInfo.routePassPointList" :key="o.stationId">
                  <template v-if="i === 0">
                    <td class="td_title F3-R-15 bgc8">出発地</td>
                    <td colspan="3" class="F1-R-20">
                      <div class="contentSty">
                        {{ o.stationName }}
                      </div>
                    </td>
                  </template>
                  <template v-if='i && i !== 0 && i !== routeInfo.routePassPointList.length -1'>
                    <td class="td_title F3-R-15 bgc8">停留所 {{ i }}</td>
                    <td colspan="3" class="F1-R-20">
                      <div class="contentSty">
                        {{ o.stationName }}
                      </div>
                      </td>
                  </template>
                  <template v-if='routeInfo.routePassPointList.length - 1 === i'>
                    <td class="td_title F3-R-15 bgc8">終着地</td>
                    <td colspan="3" class="F1-R-20">
                      <div class="contentSty">
                        {{ o.stationName }}
                      </div>
                    </td>
                  </template>
                </tr>
                <tr>
                  <td class="td_title F3-R-15 bgc8">ルート距離</td>
                  <td class="F1-R-20">
                    <div class="contentSty">
                      {{ routeInfo.routeDistance | distanceFormatter }}
                    </div>
                    </td>
                  <td class="td_title F3-R-15 bgc8">ルート所要時間</td>
                  <td class="F1-R-20">
                    <div class="contentSty">
                      {{ routeInfo.routeTotalTime | timeFormatter }}
                    </div>
                  </td>
                </tr>
              </table>
            </div>
            <div class="modal-footer">
              <button class="btn btn-default F2-M-24 T7-larginbtn" data-dismiss="modal" @click="commitServer()">確定</button>
            </div>
          </div>
        </div>
      </div>
    </div>
</div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data () {
    return {
      }
  },
  computed: {
    ...mapState({
      // 需要显示的值
      routeInfo: state => state.loginRouterinfo,
      // 需要提交的值
      routeInfos: state => state.loginRouterinfos
    })
  },
  created () {
  },
  methods: {
    commitServer () {
      if (this.routeInfo.flag === 'add') {
        this.routeInfos.routeName = this.routeInfos.routeName.trim()
        this.$axios.post('route/saveRouteData', { viewModelData: this.routeInfos }).then(result => {
          this.$router.push({path: '/RouteList'})
        }).catch(err => {
          console.log(err)
        })
      } else if (this.routeInfo.flag === 'edit') {
        this.routeInfos.routeName = this.routeInfos.routeName.trim()
        this.$axios.post('route/updateRouteData', { viewModelData: this.routeInfos }).then(result => {
          sessionStorage.setItem('clickRoute', JSON.stringify(this.routeInfos))
          this.$router.push({path: '/RouteEvent'})
        }).catch(err => {
          console.log(err)
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.modal-dialog {
  margin-top: 5%;
  width: 70%;
  .modal-content {
    width: 100%;
    .modal-header {
      border-bottom: 0px;
      text-align: center;
    }
    .modal-body {
      .div_top {
        width: 96%;
        margin: 0px auto;
        margin-bottom: 10px;
        .tb_top {
          border: 2px solid rgb(148, 148, 148);
          width: 100%;
          border: 1px solid gray;
          border-collapse: collapse;
          .td_title {
            background-color: #dcdcdc;
            width: 150px;
            text-align: center;
          }
        }
      }
      .modal-footer {
        margin: 20px auto;
        border-top: 0px;
        .btn-default {
          width: 40%;
          margin-right: 30%;
          background: #6f6f6f;
          border-radius: 8px;
          color: #ffffff;
          font-size: 20px;
        }
        .T7-larginbtn {
          border-radius: 10px;
          background: linear-gradient(#70b6ca 50%, #48a3be 50%) !important;
          background-color: #717171;
          height: 50px;
        }
      }
    }
  }
}
.tb_top tr td {
    text-align: left;
    height: 45px;
    line-height: 30px;
    border: 1px solid gray;
}
.contentSty {
  position: relative;
  left: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/NewLoginConfirm.vue